export default __webpack_public_path__ + "static/media/npm.70414569.svg";